import 'url-polyfill';
import VueResource from 'vue-resource';
import Vue from 'vue';

Vue.use(VueResource);

const urlPrefix = `${window.location.origin}${window.SITE_URL}`;

export default {
  getArticles(params) {
    const query = {};
    Object.keys(params).forEach((filterAttr) => {
      const queryKey = filterAttr.replace(
        /([A-Z])/g,
        m1 => `_${m1.toLowerCase()}`,
      );
      query[queryKey] = params[filterAttr];
    });

    // decode the keywords first decodeURI(${params.keyword})
    const decodedKeyword = params.keyword ? decodeURI(params.keyword) : null;

    let url;
    if (params.keyword !== undefined) {
      url = new URL(
        `article/ajax/${params.articleType}/${params.ics}/${params.limit}/${params.page}/${decodedKeyword}`,
        urlPrefix,
      );
    } else {
      url = new URL(
        `article/ajax/${params.articleType}/${params.ics}/${params.limit}/${params.page}`,
        urlPrefix,
      );
    }

    return Vue.http
      .get(url.href, {
        // params: query,
      })
      .then(res => res.json());
  },

  getArticlesById(params) {
    const url = new URL(
      `article/getArticleDetailJson/${params.postid}`,
      urlPrefix,
    );

    return Vue.http.get(url.href, {}).then(res => res.json());
  },

  getOverallrticles() {
    const url = new URL('transaction/json', urlPrefix);
    return Vue.http.get(url.href, {}).then(res => res.json());
  },
};
